module.exports = __webpack_public_path__ + "img/shipper.1c989cfa.svg";